import { useEffect } from "react";
import { useStoreDispatch } from "../../store/hooks";
import { setConfigAlertCount, setNotrificationCount, setOpenToast } from "../../store/helpers/helperReducers";
import { useGetConfigAlertsQuery, useUpdateConfigAlertsMutation } from "../../store/api/deviceConfig/deviceConfigApiSlice";
import { API, LOCAL_STORAGE } from "../../globals/globals";
import { useSelector } from "react-redux";
import { isLoggedInSelector, selectProfilePermissionsSelector } from "../../store/api/auth/selectors";
import { IConfigAlert } from "../../store/api/deviceConfig/types";
import { errorMessage } from "../../utils/helpers";
import ProfilePermissions from "../../utils/ProfilePermissions";

interface IConfigAlertN {
  id: number;
  status: string;
  description: string;
  timestamp: string;
}

export const useConfigAlertData = () => {
  const dispatch = useStoreDispatch();

  const isLoggedIn = useSelector(isLoggedInSelector);
  const [updateConfigAlerts] = useUpdateConfigAlertsMutation();
  const username = localStorage.getItem(LOCAL_STORAGE.USER);
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);

  const args = { filters: `userId=${username}` };
  const { data, isLoading, refetch } = useGetConfigAlertsQuery(args, {
    pollingInterval: isLoggedIn ? API.ENDPOINTS.CONFIGALERTS.pollingInterval || undefined : undefined,
  });

  useEffect(() => {
    !!data && data?.length >= 0 && dispatch(setConfigAlertCount(data?.length));
  }, [data, dispatch]);

  const acklnowledgeHandler = async (event: React.MouseEvent, rowId: number | string) => {
    if (!permissions?.hasOpCodeGroup("manage_topology")) return;
    let ackIds: Array<number>;
    if (typeof rowId === "string" && rowId === "CLEARALL") {
      ackIds = !!data && data?.length > 0 ? data.map((item: IConfigAlert) => Object.keys(item).map((keyitem) => keyitem === "id") && item.id) : [];
    } else {
      ackIds = [Number(rowId)];
    }

    try {
      let result: any;
      result = await updateConfigAlerts({ ackIds, queryParam: `userId=${username}` });
      if (result?.error) throw result?.error;
      if (result.data?.status === 200) {
        refetch();
        dispatch(
          setOpenToast({
            openToast: true,
            toastType: "success",
            message: `Config alert has been acknowledge`,
          })
        );
      }
    } catch (error: any) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  return {
    permissions,
    data,
    isLoading,
    refetch,
    acklnowledgeHandler,
  };
};

export const useNotificationData = () => {
  const dispatch = useStoreDispatch();
  const mockData: IConfigAlertN[] = [
    {
      id: 1,
      status: "Synced",
      description: "<radionnode_name> has been disabled.This process may take several minutes.",
      timestamp: "July 4, 2023; 00:00:00",
    },
    {
      id: 2,
      status: "Fail",
      description: "<radionnode_name> has been disabled.This process may take several minutes.",
      timestamp: "July 4, 2023; 00:00:00",
    },
    {
      id: 3,
      status: "pending",
      description: "<radionnode_name> has been disabled.This process may take several minutes.",
      timestamp: "July 4, 2023; 00:00:00",
    },
    {
      id: 4,
      status: "Success",
      description: "<radionnode_name> has been disabled.This process may take several minutes.",
      timestamp: "July 4, 2023; 00:00:00",
    },
  ];

  useEffect(() => {
    dispatch(setNotrificationCount(mockData.length));
  });
  return {
    mockData,
  };
};
